import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import userinfo from "./userinfo";
import enterprise from "./enterprise";
import app from "./app";
export default new Vuex.Store({
    modules: {
        app,
        userinfo,
        enterprise,
    },
});
